export const SET_DISCOUNTS = 'SET_DISCOUNTS'
export const SET_STEP = 'SET_STEP'
export const SET_FORM_DATA = 'SET_FORM_DATA'
export const SET_EVENT = 'SET_EVENT'
export const SET_EVENT_DATE = 'SET_EVENT_DATE'
export const SET_EXTENSIONS = 'SET_EXTENSIONS'
